module.exports = __webpack_public_path__ + "static/img/home_yali_photo5@2x.fcb0177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_yali_photo5@2x.png
// module id = ADRC
// module chunks = 0